import InformationModal from "./InformationModal";

export default InformationModal;